import { PlaySymbolSoundCommand } from 'slotworks/commands/symbols/play-symbol-sound-command';
import Components from 'slotworks/components/components';
import Layers from 'slotworks/graphics/layers/layers';
import currency from 'slotworks/i18n/currency';
import LineResult from 'slotworks/model/gameplay/records/results/line-result';
import { SoundEvent } from 'slotworks/sound/sound-events';
import soundManager from 'slotworks/sound/sound-manager';
import SoundManager from 'slotworks/sound/sound-manager';
import Contract from 'slotworks/utils/contract';
import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';

export default class CelebrateWinsComponent {
    public MULTIPLIER_MOVE_TIME: number = 300;
    public SCALE_TIME: number = 150;
    public TOTAL_COUNTUP_TIME: number = 750;
    public TOTAL_WAIT_TIME: number = 750;

    private tween: TweenJS.Tween;
    private timer: number;

    private tickUpComplete: boolean;
    private transitionComplete: boolean;
    private completeResolve: Function;

    public totalWin(win: number, multiplier: number = 1, initialWin: number = 0) {
        return new Contract<void>(resolve => {
            this.tickUpComplete = this.transitionComplete = false;
            this.completeResolve = () => resolve(null);
            this.clear();

            if (win <= 0 || !Layers.CelebrationContent.hasScene('totalWin')) {
                resolve(null);
                return;
            }

            const setup = () => {
                soundManager.event(SoundEvent.tickup_totalwin_start);
                Components.footer.showGameWin(win);
                this.tickUp(Layers.CelebrationContent.getText('value'), win, this.TOTAL_COUNTUP_TIME, this.TOTAL_WAIT_TIME, multiplier, initialWin);
            };

            Layers.CelebrationContent.setScene('totalWin', setup).then(() => {
                this.transitionComplete = true;
                this.complete();
            });
        });
    }

    public singleTotalWin(win: number, result: LineResult, multiplier: number = 1, initialWin: number = 0) {
        return new Contract<void>(resolve => {
            this.tickUpComplete = this.transitionComplete = false;
            this.completeResolve = () => resolve(null);
            this.hide();

            if (win <= 0 || !Layers.CelebrationContent.hasScene('totalWin')) {
                resolve(null);
                return;
            }

            const setup = () => {
                if (result.symbolType != undefined) PlaySymbolSoundCommand(result.symbolType, result.matches.toString(), '1');
                Components.footer.showGameWin(win);
                this.tickUp(Layers.CelebrationContent.getText('value'), win, this.TOTAL_COUNTUP_TIME, this.TOTAL_WAIT_TIME, multiplier, initialWin);
            };

            Layers.CelebrationContent.setScene('totalWin', setup).then(() => {
                this.transitionComplete = true;
                this.complete();
            });
        });
    }

    private clear() {
        if (this.tween) {
            soundManager.event(SoundEvent.tickup_anywin_end);
            this.tween.stop();
        }
        Timer.clearTimeout(this.timer);
        Layers.CelebrationContent.jumpToScene('default');
    }

    public lineWin(win: number, line?: number, symbol?: string, matches?: number, row?: number, multiplier: number = 1, initialWin: number = 0) {
        return new Contract<void>(resolve => {
            this.tickUpComplete = this.transitionComplete = false;
            this.completeResolve = () => resolve(null);

            this.hide();

            if (win <= 0) {
                resolve(null);
                return;
            }

            const scene = Layers.CelebrationContent.getFirstValidScene([`line_${line}_${matches}_win`, `line_${line}_win`, `line_row_${row}_win`, 'line_win', 'lineWin']);
            if (scene) {
                const setup = () => {
                    SoundManager.event(SoundEvent.tickup_linewin_start);
                    Components.footer.showLineWin(line, win, symbol, matches);
                    this.tickUp(Layers.CelebrationContent.getText('value'), win, this.TOTAL_COUNTUP_TIME, this.TOTAL_WAIT_TIME, multiplier, initialWin);
                };

                Layers.CelebrationContent.setScene(scene, setup).then(() => {
                    this.transitionComplete = true;
                    this.complete();
                });
            } else {
                resolve(null);
            }
        });
    }

    public hide() {
        if (this.tween) {
            SoundManager.event(SoundEvent.tickup_anywin_end);
            this.tween.stop();
        }
        Timer.clearTimeout(this.timer);
        Layers.CelebrationContent.jumpToScene('default');
    }

    private tickUp(text: PIXI.Text, targetValue: number, duration: number, wait: number, multiplier: number, initialValue: number = 0) {
        soundManager.event(SoundEvent.tickup_anywin_start);
        const midValue = initialValue > 0 ? initialValue : targetValue;

        const tickObj = {
            value: 0
        };
        this.tween = new TweenJS.Tween(tickObj)
            .to({ value: midValue }, duration)
            .onUpdate(() => {
                text.text = currency.format(tickObj.value, undefined, undefined, true, true);
            })
            .onComplete(() => {
                text.text = currency.format(tickObj.value, undefined, undefined, true);
                soundManager.event(SoundEvent.tickup_anywin_end);
                this.timer = Timer.setTimeout(() => {
                    this.tickUpComplete = true;
                    this.complete();
                }, wait);
            })
            .start();
    }

    private complete() {
        if (this.completeResolve && this.tickUpComplete && this.transitionComplete) {
            Layers.CelebrationContent.defaultScene().then(() => {
                if (this.completeResolve) this.completeResolve();
                this.completeResolve = null;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/transitions/celebrate-win-component.ts